import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Editbox from '../../../Part_Sample/Editbox';
import Select from '../../../Part_Sample/Select';
import { login } from './js/clouddevice';

export default class UniviewLogin extends Component {
	constructor(props) {
		super(props);

		let username = '';
		let password = '';
		let num_screen = 2;

		let uniview_info = JSON.parse(window.localStorage.getItem('uniview_info'));
		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		this.controller_mac_addr = controller_info.mac_addr;
		this.controller_username = controller_info.username;

		if (uniview_info == null || uniview_info == undefined || uniview_info == []) {
			uniview_info = {};
			uniview_info[this.controller_mac_addr] = {};
			uniview_info[this.controller_mac_addr][this.controller_username] = { username: "", password: "", num_screen: 2 };
			window.localStorage.setItem('uniview_info', JSON.stringify(uniview_info));
		} else if (uniview_info[this.controller_mac_addr] == null) {
			uniview_info[this.controller_mac_addr] = {};
			uniview_info[this.controller_mac_addr][this.controller_username] = { username: "", password: "", num_screen: 2 };
			window.localStorage.setItem('uniview_info', JSON.stringify(uniview_info));
		}

		if (uniview_info[this.controller_mac_addr][this.controller_username] == null) {
			uniview_info[this.controller_mac_addr][this.controller_username] = { username: "", password: "", num_screen: 2 };
			window.localStorage.setItem('uniview_info', JSON.stringify(uniview_info));
		}

		username = uniview_info[this.controller_mac_addr][this.controller_username].username;
		password = uniview_info[this.controller_mac_addr][this.controller_username].password;
		num_screen = uniview_info[this.controller_mac_addr][this.controller_username].num_screen;

		let drop_down_list = [];
		drop_down_list.push(<option value={2} key={2}>{2}</option>);
		drop_down_list.push(<option value={3} key={3}>{3}</option>);
		drop_down_list.push(<option value={4} key={4}>{4}</option>);
		drop_down_list.push(<option value={6} key={6}>{6}</option>);
		drop_down_list.push(<option value={8} key={8}>{8}</option>);

		this.state = {
			username: username,
			password: password,
			num_screen: num_screen,
			drop_down_list: drop_down_list,
			is_checked: false
		}
	}

	// Goes to previous screen
	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('IPCam_Settings');
	}

	handleChangeUsername = (val) => {
		this.setState({ username: val })
	}

	handleChangePassword = (val) => {
		this.setState({ password: val })
	}

	//Save Uniview Settings
	handleRegister = () => {
		let uniview_info = JSON.parse(window.localStorage.getItem('uniview_info'));
		let user_info = uniview_info[this.controller_mac_addr][this.controller_username];
		user_info.username = this.state.username;
		user_info.password = this.state.password;
		user_info.num_screen = this.state.num_screen;
		uniview_info[this.controller_mac_addr][this.controller_username] = user_info;
		window.localStorage.setItem('uniview_info', JSON.stringify(uniview_info));
		// Kaiwei 20210216 save Success no need message, just redirect to previous page
		this.handlePrevious();
	}

	//Check Account Details
	handleLeftButtonAction = () => {
		// Form validation
		if (this.state.username == '' || this.state.password == '') {
			window.app.showToast(this.props.receiver.getString('ipcam_fillblanks'), 3000);
			return;
		}

		window.app.showLoading();
		login(this.checkSuccess, this.checkFailed, this.state.username, this.state.password);
	}

	checkSuccess = (result) => {
		window.app.hideLoading();
		window.app.showToast(this.props.receiver.getString('uniview_login_success'), 3000);
	}

	checkFailed = () => {
		window.app.hideLoading();
		window.app.showToast(this.props.receiver.getString('login_failed'), 3000);
	}

	//Add Camera
	addCamera = () => {
		// Form validation
		if (this.state.username == '' || this.state.password == '') {
			window.app.showToast(this.props.receiver.getString('ipcam_fillblanks'), 3000);
			return;
		}

		window.app.showLoading();
		login(this.loginSuccess, this.loginFailed, this.state.username, this.state.password);
	}

	loginSuccess = (result) => {
		window.app.hideLoading();

		// Save user's username and password
		let uniview_info = JSON.parse(window.localStorage.getItem('uniview_info'));
		let user_info = uniview_info[this.controller_mac_addr][this.controller_username];
		user_info.username = this.state.username;
		user_info.password = this.state.password;
		user_info.num_screen = this.state.num_screen;
		uniview_info[this.controller_mac_addr][this.controller_username] = user_info;
		window.localStorage.setItem('uniview_info', JSON.stringify(uniview_info));

		// Remove the last comma
		if (result.substring(result.length - 1, result.length) == ',') result = result.substring(0, result.length - 1);
		sessionStorage.setItem('devices', result);

		// Pass parameters to UniviewCameras screen
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('UniviewCameras');
	}

	loginFailed = () => {
		window.app.hideLoading();
		window.app.showToast(this.props.receiver.getString('login_failed'), 3000);
	}

	handleSelectNumScreens = (key) => {
		this.setState({
			num_screen: key
		});
	}

	render() {
		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			textAlign: 'right',
			color: 'white',
			height: this.props.height,
		}

		let container_style = {
			justifyContent: 'center',
			alignItems: 'center',
			textAlign: 'left',
			height: this.props.height - 140,
			paddingBottom: 60,
			overflow: 'auto'
		}

		let roundedLayout = {
			borderRadius: 5,
			background: '#f9f9f9',
			padding: 15,
			margin: 10,
		}

		let inputContainer = {
			backgroundColor: 'transparent',
			border: 'none',
			padding: 10,
			outline: 'none',
			textAlign: 'left',
			width: '100%'
		}

		let buttonContainer = {
			backgroundColor: 'transparent',
			border: 'none',
			outline: 'none',
			textAlign: 'center',
		}

		let buttonRoundedLayout = {
			borderRadius: 5,
			background: '#44C8F5',
			padding: 15,
			margin: 10,
		}

		return (
			<div>
				<div style={main_content_style} className='slideInDown'>

					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('uniview')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'add'}
						handleRightButton={this.addCamera}
					/>

					{/* <div style={{ paddingTop: 20, paddingBottom: 20, alignItems: 'center', zIndex: 999 }}>
                        <div style={{ width: 100, display: 'inline-block', textAlign: 'left' }} onClick={this.handlePrevious}>
                            <img src={left} style={{ width: 20, height: 20, marginLeft: 30 }} />
                        </div>
                        <div style={{ width: this.props.width - 200, maxWidth: this.props.width - 200, textAlign: 'center', display: 'inline-block' }}>
                        </div>
                        <div style={{ width: 100, display: 'inline-block', textAlign: 'right' }} onClick={this.handleAddDevice}>
                        </div>
                    </div> */}

					{/* 
					<div style={{ width: 100, display: 'inline-block', textAlign: 'left', }} onClick={this.handlePrevious}>
						<img src={left} style={{ width: 20, marginTop: 10, marginLeft: 10 }} />
					</div>
					<div style={{ width: this.props.width - 200, textAlign: 'center', display: 'inline-block' }}>
						<span className="header">{'Uniview'}</span>
					</div>
					<div style={{ display: 'inline-block', width: 100, textAlign: 'right' }} >
					</div> */}

					{/* Field Inputs  */}
					<div style={container_style}>
						<div style={{ textAlign: 'center', marginLeft: 20 }}>
							<Editbox id='username' style={{ width: this.props.width - 40, color: 'black' }} placeholder={this.props.receiver.getString('usrname')} inputType='text' onChange={(event) => this.handleChangeUsername(event.target.value)} value={this.state.username} />
						</div>
						<div style={{ textAlign: 'center', marginLeft: 20, marginTop: 20 }}>
							<Editbox id='password' style={{ width: this.props.width - 40, color: 'black' }} placeholder={this.props.receiver.getString('passwd')} inputType='password' onChange={(event) => this.handleChangePassword(event.target.value)} value={this.state.password} />
						</div>
						<div style={{ marginTop: 20, marginLeft: 20, display: 'inline-block' }}>
							<span style={{ color: 'black', display: 'inline-block' }}>{this.props.receiver.getString("ipcam_numberscreens")}</span>

							{/* Tommy - 29/03/2021 */}
							<Select
								style={{ display: 'initial', marginLeft: 20 }}
								select_style={{ width: 'auto' }}
								options={this.state.drop_down_list}
								value={this.state.num_screen}
								onSelect={this.handleSelectNumScreens}
							/>

							{/* <Dropdown
								style={{ display: 'inline-block', marginLeft: 20}}
								dropdown_style={{ maxHeight: this.props.height - 180 }}
								header_style={{ fontSize: 26 }}
								header={this.state.num_screen}
								list={this.state.drop_down_list}
								handleListOnClick={this.handleSelectNumScreens}
								handeListOnMove={this.handleOnMouseMove}
							/> */}
						</div>
					</div>
				</div>
			</div>
		)
	}
}